export default class Origin {

  constructor({ name, color, description }) {
    this.name = name;
    this.color = color;
    this.description = description;
  }
}